import React, { useContext, useState } from 'react';
import { Modal, ScrollView, Text, View } from 'react-native';
import { Button } from '@rneui/themed';
import LayoutContext from '../../../contexts/Layout';

import CheckBox from 'expo-checkbox';
import { HorizontalRule } from '../../common/HorizontalRule';

const FilterMenu = props => {
    const { layout } = useContext(LayoutContext);
    const [tempFilters, setTempFilters] = useState([]);
    const [filterMenuVisible, setFilterMenuVisible] = props.filterState;
    const filters = props.filters;

    if (!filterMenuVisible || filters?.length === 0) {
        return null;
    }

    const toggleFilterMenu = () => {
        setFilterMenuVisible(!filterMenuVisible);
    };

    const onApplyFilters = () => {
        if (props.applyFilters) {
            props.applyFilters(tempFilters);
        }

        toggleFilterMenu();
    };

    const toggleFilterSelection = (selection, category, label) => {
        if (!category.equals('all', true)) {
            filters.all.isChecked = false;

            if (category.equals('campuses')) {
                const campus = filters.campuses.find(filter => filter.label.equals(label));

                if (campus) {
                    campus.isChecked = selection;
                }
            } else if (category.equals('ministries')) {
                const ministry = filters.ministries.find(filter => filter.label.equals(label));

                if (ministry) {
                    ministry.isChecked = selection;
                }
            }
        } else {
            filters.all.isChecked = true;

            filters.campuses.forEach(filter => (filter.isChecked = false));
            filters.ministries.forEach(filter => (filter.isChecked = false));
        }

        setTempFilters({ ...filters });
    };

    const renderCheckbox = (color, text, value, isChecked) => {
        return (
            <View key={text} style={{ flexDirection: 'row', marginVertical: 10 }}>
                {!!color && <View style={{ backgroundColor: color, height: 25, marginRight: 5, width: 10 }} />}
                <CheckBox
                    color='#153d6e'
                    onValueChange={checked => toggleFilterSelection(checked, value, text)}
                    style={{ height: 25, marginRight: 10, marginLeft: !color ? 15 : 0, width: 25 }}
                    value={isChecked}
                />
                <Text>{text}</Text>
            </View>
        );
    };

    return (
        <Modal animationType='slide' visible={filterMenuVisible} onRequestClose={() => setFilterMenuVisible(false)}>
            <ScrollView style={{ flex: 1, marginHorizontal: 25, marginVertical: 25 }}>
                <View style={{ alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <Text
                        style={{
                            fontFamily: 'GothamBook',
                            fontSize: layout.device.os.equals('web') ? '18pt' : 18,
                            letterSpacing: 0,
                            lineHeight: layout.device.os.equals('web') ? '20pt' : 20,
                            marginBottom: 10
                        }}
                    >
                        Filter By:
                    </Text>
                    <Button
                        buttonStyle={{ backgroundColor: 'transparent' }}
                        icon={{
                            color: '#8897a2',
                            name: 'times',
                            size: 18,
                            type: 'font-awesome-5'
                        }}
                        onPress={() => {
                            setFilterMenuVisible(false);
                        }}
                        iconContainerStyle={{ paddingRight: 4 }}
                    />
                </View>

                {renderCheckbox(undefined, 'All', 'all', filters.all.isChecked)}

                <HorizontalRule />
                {filters.campuses &&
                    filters.campuses.map(campus => {
                        return renderCheckbox(campus.color, campus.label, 'campuses', campus.isChecked);
                    })}
                <HorizontalRule />
                {filters.ministries &&
                    filters.ministries.map(ministry => {
                        return renderCheckbox(ministry.color, ministry.label, 'ministries', ministry.isChecked);
                    })}
                <Button
                    buttonStyle={{ backgroundColor: '#a61a2b' }}
                    containerStyle={{ marginTop: 20 }}
                    onPress={onApplyFilters}
                    title='Apply'
                    titleStyle={{ color: '#fff' }}
                />
            </ScrollView>
        </Modal>
    );
}; //, [applyFilters, filters, filterMenuVisible, layout.device.os, tempFilters]);

export default FilterMenu;
